import React from 'react';
import { Card, SageClassnames } from '@kajabi/sage-react';

import type { MessageType } from 'common/components/CopyMagic/contexts/MessagesContext/MessagesContext.types';

type Props = {
  message: MessageType;
};

const User = ({
  message: {
    data: { content },
  },
}: Props) => (
  <Card
    className={[
      'copy-magic-conversation-assistant-message',
      'copy-magic-conversation-assistant-message--user',
      SageClassnames.TYPE.BODY_SMALL_MED,
    ].join(' ')}
    compact
    data-testid="message-user"
  >
    {content}
  </Card>
);

export default User;
